
import { Component, Vue, Prop } from 'vue-property-decorator'
import { IAppForm } from './IAppForm'
import { ApplicationModule, DataModule, WizardModule } from '@/store'

	@Component({
	  name: 'FinanceDetails'
	})
export default class FinanceDetails extends Vue implements IAppForm {
  // #region Props

		@Prop() wizardIndex!: number;

		// #endregion

		// #region Data

		get value () {
		  return ApplicationModule.form
		}

		// #endregion

		// #region Methods

		submit () {
		  if (!this.validate()) { return }

		  this.$emit('submit', this.wizardIndex)
		}

		previous () {
		  this.$emit('previous')
		  ApplicationModule.updateForm(ApplicationModule.formCopy)
		}

		validate () {
		  return true
		}

		setValue (val: number) {
		  this.value.vehicleType.id = val

		  if (val !== 0) {
		    setTimeout(() => { this.submit() }, 500)
		  }
		}

		// #endregion

		// #region Computed

		get vehicles () {
		  return DataModule.vehicles
		}

		get vehicleName () {
		  const obj = this.vehicles.find(v => v.value === this.value.vehicleType.id)

		  return this.value.vehicleType.id && this.value.vehicleType.id > 0 && obj ? obj.label : ''
		}

		get isPrePopped () {
		  return ApplicationModule.isPrePopped
		}

		get callback () {
		  return WizardModule.callback
		}
  // #endregion
}
